exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group[data-v-03ffdf1a]{height:350px;overflow:auto}.nestable-item[data-v-03ffdf1a]{cursor:pointer;padding:5px;width:300px;background:#fff;border:1px dotted #ccc;border-radius:4px;font-size:13px;color:#6c757d;margin-bottom:10px}.wrap-list input[data-v-03ffdf1a]{color:#6c757d;font-size:12px;display:block;width:100%;font-size:13px;height:34px;line-height:10px;border-width:1px 0;border-top:1px solid transparent;border-bottom:1px solid #e2e2e2;outline:none;margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03ffdf1a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app_modules/SortableProducts.vue
// module id = 198
// module chunks = 0